import type {MosaicsMode} from '@src/constants/mosaics.ts';
import type {MosaicsState, StateSlice} from '@src/stores/types.ts';
import type {Mosaic} from '@src/types/mosaics.ts';
import type {Feature} from 'geojson';
import {MODES} from '@src/constants/mosaics.ts';

export const initialState = {
  selected: null, // definition of the selected mosaic.
  mode: MODES.MOSAICS,
  focusedQuadFootprints: {},
  hoveredQuadFootprints: {},
};

export const setMosaicSlice: StateSlice<MosaicsState> = set => ({
  ...initialState,
  setMosaicsMode: (mode: MosaicsMode) =>
    set(
      state => {
        state.mosaics.mode = mode;
      },
      undefined,
      'mosaics/setMosaicsMode',
    ),
  setSelectedMosaic: (mosaic: Mosaic | null) =>
    set(
      state => {
        state.mosaics.selected = mosaic;
      },
      undefined,
      'mosaics/setSelectedMosaic',
    ),
  setFocusedQuadFootprints: (quads: Feature[]) =>
    set(
      state => {
        state.mosaics.focusedQuadFootprints = {
          ...state.mosaics.focusedQuadFootprints,
          ...Object.fromEntries(
            quads.map((item: Feature) => [item.id, item.geometry]),
          ),
        };
      },
      undefined,
      'mosaics/setFocusedQuadFootprints',
    ),
  removeFocusedQuadFootprintsById: (quadIds: string[]) =>
    set(
      state => {
        quadIds.forEach(id => delete state.mosaics.focusedQuadFootprints[id]);
      },
      undefined,
      'mosaics/removeFocusedQuadFootprintsById',
    ),

  setHoveredQuadFootprints: (quads: Feature[]) =>
    set(
      state => {
        state.mosaics.hoveredQuadFootprints = Object.fromEntries(
          quads.map((item: Feature) => [item.id, item.geometry]),
        );
      },
      undefined,
      'mosaics/setHoveredQuadFootprints',
    ),
  reset: () =>
    set(
      state => {
        state.mosaics.mode = initialState.mode;
        state.mosaics.selected = initialState.selected;
        state.mosaics.focusedQuadFootprints =
          initialState.focusedQuadFootprints;
        state.mosaics.hoveredQuadFootprints =
          initialState.hoveredQuadFootprints;
      },
      undefined,
      'mosaics/reset',
    ),
});
